import { BasePage } from '@/components/ui/base-page'

export function VenturePage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add VenturePage specific content here */}
    </BasePage>
  )
}